.stack {
  display: flex;
  flex-direction: column;
  gap: var(--spacing-4);
}

.eyebrow {
  font-size: var(--font-size-s);
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: var(--color-grey-light);
}

.plan {
  border: 1px solid var(--color-grey-lighter);
  border-radius: 8px;
  padding: 12px 14px;
  font-size: var(--font-size-s);
  color: var(--color-grey-dark);
}

.planLine + .planLine {
  margin-top: 6px;
}

.moves {
  margin: 6px 0 0;
  padding-left: 18px;
  color: var(--color-grey);
}

.foot {
  display: flex;
  justify-content: flex-end;
  gap: var(--spacing-2);
  margin-top: var(--spacing-4);
}
